import React from 'react';
import CaregiverCard from './CaregiverCard';
import BaseBadge from '../badges/BaseBadge';
import { CheckIcon, DisabledIcon } from '../icons';
import { PROFESSIONAL_STATUSES } from '../../constants';
import ClockIcon from '../../assets/images/clock-icon.svg';

import './CaregiverCard.scss';

/**
 * NameBadges component.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.caregiver - The caregiver object.
 * @returns {React.JSX.Element} - JSX element representing the NameBadges.
 */
const NameBadges = ({ caregiver }) => {
	if (caregiver.is_active) {
		if (caregiver.is_disabled) {
			return <BaseBadge badgeCopy="Disabled" className="cancelled-badge" icon={<DisabledIcon />} />;
		}
		if (caregiver.worker_status === PROFESSIONAL_STATUSES.ENABLED) {
			return <BaseBadge badgeCopy="Enabled" className="confirmed-badge" icon={<CheckIcon />} />;
		}
		if (caregiver.worker_status === PROFESSIONAL_STATUSES.PENDING) {
			return <BaseBadge badgeCopy="Pending" className="pending-badge" icon={<img src={ClockIcon} alt="" />} />;
		}
	}

	return <BaseBadge badgeCopy="Deactivated" className="deactivated-badge" icon={<DisabledIcon />} />;
};

/**
 * CaregiverCardInternalStaff component.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.caregiver - The caregiver object.
 * @returns {JSX.Element} - JSX element representing the CaregiverCardInternalStaff.
 */
const CaregiverCardInternalStaff = ({ caregiver, onCaregiverWorkerStatusAction }) => (
	<CaregiverCard
		caregiver={caregiver}
		hideStats
		hideContactInfo={!caregiver.is_active}
		nameBadge={<NameBadges caregiver={caregiver} />}
		onCaregiverWorkerStatusAction={onCaregiverWorkerStatusAction}
	/>
);

export default CaregiverCardInternalStaff;
